import { Injectable } from '@angular/core';
import { CanActivate, Router } from "@angular/router";
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {

  constructor(private api: ApiService, private router: Router) {
  }

  canActivate(): boolean {    

    if (!this.api.authorized) {

      this.api.logout();
      this.router.navigateByUrl('/login');
      return false;
    }

    return true;
  }
}
